const smsRegex: RegExp = /^\+\d{10,}$/

export const isValidSms = (sms: string): boolean => smsRegex.test(sms)
